import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom"; // Add this import
import "../feautreSelectionScreen.css";
import { Autocomplete, Box, Button, TextField, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Add this import
import AnimatedContainer from "../widget/animatedContainer";
import store from "../../../../stateManagement/store";
import ArrowRightAltTwoToneIcon from "@mui/icons-material/ArrowRightAltTwoTone";
import {
  featureSelectionScreenInit,
  getFinalMetaDataPayloadFeatureSelection,
  getStudioConfigMap,
  updateConfigFeatureSelection,
} from "../../../../services/uiConfigService";
import { openPopup } from "../../../../stateManagement/actions/popupActions"
import { otherConfigOptionsAttributes } from "../../mandatoryConfigs/configSetupScreen/widget/configBottomBar";
import { FeatureSelectionOptionsContext } from "../../../settings/components/FeatureSelectionOptionsContext";
import { AppOptionType, OptionType } from "../../../manageHomepage/ManageHomePageTypes";
import { setCurrentAppType, setCurrentRole } from "../../../../stateManagement/actions/roleActions";
import { useSelector } from "react-redux";
import Loader from "../../../../components/loading/Loader";
import RequiredConfigModal from "../components/requiredConfigModal";
import { usePopup } from "../../../../components/newPortal/PopUpContext";
import { StudioRoleSelectionAndSavePopupModal } from "../../../../components/newPortal/components/studioRoleSelectionAndSavePopupModal";

export interface FeatureSelectionScreenPropsTypes {
  handleStepIconClick ? : (stepNumber: number) => void;
  currentStep?: number;
  completed?: {
    [k: number]: boolean;
  };
  setCompleted?: React.Dispatch<
    React.SetStateAction<{
      [k: number]: boolean;
    }>
  >;
}

export default function FeatureSelectionScreen(
  props: FeatureSelectionScreenPropsTypes
) {
  const location = useLocation(); // Add this hook
  const [standard, setStandard] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const currentconfigRef=useRef<any>({})
  const [roleOptions, setRoleOptions] = useState<OptionType[]>([]);
  const [appTypeOptions, setAppTypeOptions] = useState<AppOptionType[]>([]);
  const savedRole: any = useSelector(() => store.getState().roleState.role);
  const savedAppType:any = useSelector(() => store.getState().appTypeState.appType)
  const [isFirstTime,setIsFirstTime] = useState<boolean>(true);
  const [allConfigOptions, setAllConfigOptions] = useState<
    otherConfigOptionsAttributes[]
  >([]);
  const clientConfigRef = useRef([]);
  const { showPopup } = usePopup();
  
  const {
    uiConfigOptionsProp = [],
    setUiConfigOptionsProp = () => {},
    featureChangeList=[],
    setFeatureChangeList=()=>{},
    setOnSaved=()=>{}
  } = useContext(FeatureSelectionOptionsContext);

  const isOnboarding = location.pathname.includes("onboarding");

  const handleBackClick = () => {
    window.history.back();
  };

  const handleCancel = () => {

    window.history.back();
  };

  const handleSubmit = async () => {
    if (!savedRole || !savedAppType) return;
     const studio=await getStudioConfigMap({"clientconfig":["app_feature_configuration","app_layout_configuration","app_options_configuration"]})
      currentconfigRef.current=studio
    const finalMetaDataPayload = await getFinalMetaDataPayloadFeatureSelection(savedRole,savedAppType,uiConfigOptionsProp,clientConfigRef,featureChangeList,currentconfigRef);
    if (!finalMetaDataPayload) {
      props.setCompleted?.((prev) => ({
        ...prev,
        [props.currentStep ?? 0]: true,
      }));
      props.handleStepIconClick?.(2);
      return;
    }
   
    const initialConfigMap: Record<string, any> = {"clientconfig": currentconfigRef.current["clientconfig"]};
    const updatedConfig:any[] = structuredClone(currentconfigRef.current["clientconfig"]);
    updatedConfig.forEach((config) => {
      const domainType = config.domainType;
      const feature = finalMetaDataPayload.features.find((feature) => feature.domainType === domainType);
      if(feature){
        config.domainValues = feature.domainValues;
      }
    });
    const updatedConfigMap : Record<string,any> = {"clientconfig": updatedConfig};
    const requiredConfigsMap = {
      "clientconfig" : finalMetaDataPayload?.features?.map((obj: Record<string, any>) => obj.domainType) ?? [],
    }
    const filterdinitialconfig=initialConfigMap["clientconfig"].filter((config:any)=>finalMetaDataPayload.features.find((data:any)=>data.domainType===config.domainType))
    const updatedinitialconfig=updatedConfigMap["clientconfig"].filter((config:any)=>finalMetaDataPayload.features.find((data:any)=>data.domainType===config.domainType))
    initialConfigMap["clientconfig"]=filterdinitialconfig;
    updatedConfigMap["clientconfig"]=updatedinitialconfig
    showPopup((close) => (
      <StudioRoleSelectionAndSavePopupModal
        inputData={{
          requiredConfigsMap : requiredConfigsMap,
          initialConfigMap : initialConfigMap,
          updatedConfigMap : updatedConfigMap,
          appType : savedAppType,
          role : savedRole,
          affectAppTypeSpecificConfig : false,
          featureSelectionFlag:true
        }}
        actionPostSuccess = {() => {
          props.setCompleted?.((prev) => ({
            ...prev,
            [props.currentStep ?? 0]: true,
          }));
          props.handleStepIconClick?.(2);
        setOnSaved((prev)=>!prev)
        }}
        onCancel={close}
      />
    ));
  }

  const init = async () => {
   try {
    
    await featureSelectionScreenInit(setLoading,clientConfigRef,setStandard,setAppTypeOptions,setRoleOptions,uiConfigOptionsProp,setUiConfigOptionsProp,setAllConfigOptions,savedRole,savedAppType);
   } catch (error) {
      console.log("Error in init: ", error);
      openPopup("Error", "An error occurred while initializing the configuration. Please try again later.");
   } finally {
      setLoading(false);
   }
  }
  useEffect(() => {
    init();
  }, [])
  // useEffect(()=>{
  //   if(uiConfigOptionsProp.length !== 0  && isFirstTime && savedRole){
  //     setIsFirstTime(false);
  //     updateConfigFeatureSelection(savedRole,savedAppType,uiConfigOptionsProp,clientConfigRef,setUiConfigOptionsProp,setAllConfigOptions);
  //   }
  // },[uiConfigOptionsProp])
  useEffect(() => {
    updateConfigFeatureSelection(savedRole,savedAppType,uiConfigOptionsProp,clientConfigRef,setUiConfigOptionsProp,setAllConfigOptions);
  }, [savedRole,savedAppType,uiConfigOptionsProp]);
   
  
  if (loading) {
    return <div className="config-container-left "><Loader /></div>;
  }
  return (
    <div className="feautre-selection">
      {/* Feature selection heading bar - adjusted positioning for non-onboarding */}
      <div className="feautre-selection-heading-bar" style={{
        marginLeft: !isOnboarding ? "175px" : "0px", // Shift right when not onboarding
        position: "relative"
      }}>
        {/* Add feature back button - only show if NOT onboarding */}
        {!isOnboarding && (
          <div className="add-feature-back-button" style={{
            position: "absolute",
            top: "2px",
            left: "-180px", // Position to the left of the shifted heading
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            gap: "3px",
            cursor: "pointer",
            color: "#666",
            fontSize: "20px",
            fontWeight: 600
          }}>
            <IconButton 
              onClick={handleBackClick}
              size="small"
              sx={{ 
                color: "#666",
                "&:hover": { 
                  backgroundColor: "rgba(0, 0, 0, 0.04)" 
                }
              }}
            >
              <ArrowBackIcon fontSize="medium" />
            </IconButton>
            <span onClick={handleBackClick}>Add feature</span>
          </div>
        )}
        <div
          className="heading"
          style={{
            display: "flex",
          }}
        >
          <div
            style={{
              color: "#00c6b1",
              fontWeight: "bold",
              fontSize: "24px",
              marginRight: "8px",
              marginLeft: "8px",
            }}
          >
            FEATURE
          </div>
          <div style={{ color: "#227C9D", fontSize: "24px" }}>SELECTION</div>
          <div className="autocomplete-header" style={{ display:"flex"}}>
            <Autocomplete
              options={appTypeOptions}
              value={savedAppType}
              clearIcon={null} 
              size="small"
              // fullWidth={true}
              sx={{
                paddingRight: "0px !important",
                borderRadius: "5px",
                marginLeft: "15px",
                width: "175px",
              }}
              onChange={(event, selectedAppType) => {
                if (selectedAppType && selectedAppType.id !== savedAppType.id) {
                  setCurrentAppType(selectedAppType);
                  setRoleOptions(selectedAppType.designations || []);
                  // only change role if it is not the same as the saved role
                  if(selectedAppType.designations?.[0]?.id !== savedRole?.id){
                    setCurrentRole(selectedAppType.designations?.[0]);
                  }
                }
              }}
              renderInput={(params) => (
                <TextField
                  label={"Select App Type"}
                  {...params} // Ensure this comes first to include all necessary props
                  sx={{
                    // backgroundColor: "#e0f4ff",
                    borderRadius: "5px",
                    position: "relative",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#227C9D", // Set the border color here
                      },
                      "&:hover fieldset": {
                        borderColor: "#227C9D", // Border color on hover
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#227C9D", // Border color when focused
                      },
                    },
                  }}
                  value={savedAppType}
                />
              )}
            />
            <Autocomplete
              options={roleOptions}
              value={savedRole}
              clearIcon={null}
              size="small"
              // fullWidth={true}
              sx={{
                paddingRight: "0px !important",
                borderRadius: "5px",
                marginLeft: "15px",
                width: "175px",
              }}
              onChange={(event, value) => {
                if (value && value.id !== savedRole.id) {
                  setCurrentRole(value);
                }
              }}
              renderInput={(params) => (
                <TextField
                  label={"Select Designation"}
                  {...params} // Ensure this comes first to include all necessary props
                  sx={{
                    // backgroundColor: "#e0f4ff",
                    borderRadius: "5px",
                    position: "relative",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#227C9D", // Set the border color here
                      },
                      "&:hover fieldset": {
                        borderColor: "#227C9D", // Border color on hover
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#227C9D", // Border color when focused
                      },
                    },
                  }}
                  value={savedRole}
                />
              )}
            />
          </div>
        </div>
      </div>
      {/* feature selection */}
      <div className="feautre-selection-body">
        <AnimatedContainer
          currentRole={savedRole}
          // currentAppType={savedAppType}
          allConfigOptions={allConfigOptions}
          setAllConfigOptions={setAllConfigOptions}
          setFeatureChangeList={setFeatureChangeList}
          standard={standard}
        />
        {isOnboarding && (
        <Box marginTop={2} sx={{ position: "absolute", bottom: 10, right: 25 }}>
          <Button
            endIcon={
              <ArrowRightAltTwoToneIcon
                sx={{ fontSize: { xl: "50px" }, color: "white" }}
              />
            }
            variant="contained"
            onClick={async () => {
              await handleSubmit();
            }}
            sx={{
              alignSelf: "flex-end",
              marginY: "1.2rem",
              fontSize: "16px",
            }}
          >
            NEXT STEP
          </Button>
        </Box>
      )}

        
        {!isOnboarding && (
          <Box 
            sx={{ 
              position: "fixed", 
              bottom: 23, 
              right: 23, 
              display: "flex", 
              gap: 2,
              zIndex: 1000
            }}
          >
            <Button
              variant="outlined"
              onClick={handleCancel}
              sx={{
                fontSize: "16px",
                paddingX: "24px",
                paddingY: "8px",
                borderColor: "#ccc",
                color: "#666",
                "&:hover": {
                  borderColor: "#999",
                  backgroundColor: "rgba(0, 0, 0, 0.04)"
                }
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={async () => {
                await handleSubmit();
              }}
              sx={{
                fontSize: "16px",
                paddingX: "24px",
                paddingY: "8px",
                backgroundColor: "#00c6b1",
                "&:hover": {
                  backgroundColor: "#00b19e"
                }
              }}
            >
              Save Changes
            </Button>
          </Box>
        )}
      </div>

      <RequiredConfigModal savedRole={savedRole} savedAppType={savedAppType} roleOptionsProps={roleOptions} appTypeOptions={appTypeOptions} parentCallback={()=>{
        init();
      }} />
    </div>
  )
}
